import { Rum } from "./rum";

const L9RUM = new Rum();

(window as any).L9RUM = L9RUM;
export default L9RUM;
